import NBType, { InferType } from '@netbase/nb-type'
import MetricSchema from './MetricSchema'

const PivotSchema = NBType.object().shape('PivotSchema', {
  /* @prop */
  docName: NBType.string(),
  /* @prop */
  metrics: NBType.array().of(MetricSchema),
  /* @prop */
  rowDocName: NBType.string(),
  /* @prop */
  rowTagName: NBType.string(),
  /* @prop */
  rowThemeId: NBType.number(),
  /* @prop */
  tagName: NBType.string(),
  /* @prop */
  themeId: NBType.number(),
  /* @prop */
  topicId: NBType.number()
  /* END */
})
export default PivotSchema
export type Pivot = InferType<typeof PivotSchema>
// RESERVE BELOW
